import type { Features } from '@onhandtech/onhand-fe-shared/lib/contracts/config/features'
import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { FeatureNames } from 'contracts/config/features'

import { type FeaturesState, moduleName } from './features.types'

const initialState: FeaturesState = {
  features: {
    org_register: {
      description: '',
      enabled: false,
    },
    create_mission: {
      description: '',
      enabled: false,
    },
    mission_image_upload: {
      description: '',
      enabled: false,
    },
    campaigns: {
      description: '',
      enabled: false,
    },
  },
}

const slice = createSlice({
  name: moduleName,
  initialState,
  reducers: {
    setFeatures: (state, action: PayloadAction<Features<FeatureNames>>) => {
      state.features = action.payload
    },
  },
})

export default slice
